const api = '/api/v1/a003_login.php';
import axios from 'axios';
export const loginRepository =  {
    methods: {
        async Login(userId, passwd){
            return  axios.post(api,{
                userId:userId,
                password:passwd
            } );
        }
    }
};

